// extracted by mini-css-extract-plugin
export default {"BuyMeACoffee":"BuyMeACoffee_BuyMeACoffee__rRvMj"};